import {
    firstVisibleTopBadgeColor,
    serializeDisplayChipList,
    visibleTopBadgeTexts
} from '../fields/displayMetadata';
import { isoFromDateTimeInput } from '../fields/lifecycleMetadata';
import { linesFromText, numberFromInput } from './commonEditorModel';

export const serializeSharedProductFields = (values, previousProduct = {}, archivedAt = new Date().toISOString()) => {
    const topBadges = serializeDisplayChipList(values.topBadges);
    const detailChips = serializeDisplayChipList(values.displayChips);

    return {
        status: values.status,
        visibleInAdminBuilder: Boolean(values.visibleInAdminBuilder),
        visibleInAgentBuilder: Boolean(values.visibleInAgentBuilder),
        startsAt: isoFromDateTimeInput(values.startsAt),
        expiresAt: isoFromDateTimeInput(values.expiresAt),
        autoHideAfterExpiry: Boolean(values.autoHideAfterExpiry),
        archivedAt: values.status === 'archived' ? (values.archivedAt || archivedAt) : undefined,
        isDraftOnly: Boolean(values.isDraftOnly),
        neverPublished: Boolean(values.neverPublished),
        internalNotes: linesFromText(values.internalNotesText),
        emailDisplayName: String(values.emailDisplayName || '').trim(),
        emailBullets: linesFromText(values.emailBulletsText),
        visible: Boolean(values.visible),
        quoteEligible: Boolean(values.quoteEligible),
        customerEmailEligible: Boolean(values.customerEmailEligible),
        sortOrder: Number(values.sortOrder),
        badges: visibleTopBadgeTexts(values.topBadges),
        badgeColor: firstVisibleTopBadgeColor(values.topBadges, values.badgeColor || previousProduct.badgeColor || 'primary'),
        display: {
            cardDescription: String(values.cardDescription || '').trim(),
            highlightNote: String(values.displayHighlightNote || '').trim(),
            internalAgentNote: String(values.internalAgentNote || '').trim(),
            selectedBadgeText: String(values.selectedBadgeText || '').trim() || 'Selected',
            topBadges,
            cardBadges: topBadges,
            detailChips,
            featureChips: detailChips,
            chips: detailChips
        }
    };
};

export { numberFromInput };
